import type { ChatRootState } from './chatSelectors';

interface PreviewStore {
  getState: () => ChatRootState;
  subscribe: (listener: () => void) => () => void;
}

const watched = new WeakSet<PreviewStore>();

const previewUrls = (store: PreviewStore) =>
  new Set(
    Object.values(store.getState().chat.messages).flatMap((message) =>
      message.attachments.flatMap(({ previewUrl }) =>
        previewUrl?.startsWith('blob:') ? [previewUrl] : []
      )
    )
  );

/** Observe the store, not a mounted surface: page and drawer share previews. */
export const retainChatPreviews = (store: PreviewStore) => {
  if (watched.has(store)) return;
  let retained = previewUrls(store);
  if (!retained.size) return;
  watched.add(store);

  const unsubscribe = store.subscribe(() => {
    const next = previewUrls(store);

    retained.forEach((url) => {
      if (!next.has(url)) URL.revokeObjectURL(url);
    });

    retained = next;
    if (!next.size) {
      unsubscribe();
      watched.delete(store);
    }
  });
};
